import React from 'react';

const PortalHeader = ({ role, name, onHome, onLogout }) => (
  <header className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
      <button type="button" onClick={onHome} className="flex items-center gap-3 min-w-0 text-left" aria-label="Go to SchoolVerse home">
        <img src="/shopimax-logo.png" alt="SchoolVerse" className="h-10 w-10 rounded-xl object-cover" />
        <div className="min-w-0">
          <div className="font-black text-xl leading-none text-gray-900">SchoolVerse</div>
          <div className="text-xs font-medium text-gray-500 mt-1">{role}</div>
        </div>
      </button>
      <div className="flex items-center gap-2 sm:gap-4">
        {name && <span className="hidden sm:block text-sm text-gray-600 max-w-[220px] truncate">{name}</span>}
        <button type="button" onClick={onHome} className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-100">
          <i className="fa-solid fa-house" aria-hidden="true" /> SchoolVerse
        </button>
        <button type="button" onClick={onLogout} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-900 text-white text-sm font-semibold hover:bg-gray-800 transition-colors">
          <i className="fa-solid fa-right-from-bracket" aria-hidden="true" /><span>Logout</span>
        </button>
      </div>
    </div>
  </header>
);

export default PortalHeader;
